module.exports = __webpack_public_path__ + "img/tab03.55d801a4.jpg";